import { Injectable } from '@angular/core';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';
import { Observable, catchError, map, of } from 'rxjs';
import { IDrippingListResponse } from '../../interfaces/api-response.interface';
import { IResponseArray } from '@data/interfaces/iresponseArray.interface';
import { CampaignService } from '../view/campaign.service';

/**
 * Servicio API para gestión de campañas del módulo Dripping
 */
@Injectable({
  providedIn: 'root'
})
export class ApiCampaignsService extends ApiClass {

  constructor(private campaignService: CampaignService) {
    super();
    this.path = 'dripping/campaigns';
  }

  getAll(page = 1, limit = 10, filters = {}): Observable<IDrippingListResponse> {
    const response: IDrippingListResponse = { 
      error: true, 
      msg: '', 
      data: {
        data: [],
        total: 0
      },
      status: 200,
      page: 1, 
      itemsByPage: 10, 
      totalItems: 0 
    };

    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters }).pipe(
      map((r) => {
        const drippingResponse = r as IDrippingListResponse;
        
        // Transformar cada campaña para mapear campos de relaciones populated
        if (drippingResponse.data && drippingResponse.data.data) {
          drippingResponse.data.data = drippingResponse.data.data.map((campaign: any) => ({
            ...campaign,
            // Mapear estrategia
            strategyName: campaign.strategyId?.name || 'N/A',
            // Mapear lease (usar folio)
            leaseNumber: campaign.leaseId?.folio || 'N/A',
            // Mapear cliente (usar legalName o name)
            clientName: campaign.clientId?.legalName || campaign.clientId?.name || 'N/A',
            // Canales configurados (display)
            channelsDisplay: campaign.channels?.join(', ') || 'N/A',
            // Resultado por canal (iconos con estado)
            resultsDisplay: this.campaignService.getChannelResultsDisplay(campaign)
          }));
        }
        
        return drippingResponse;
      }),
      catchError((e) => of(response))
    );
  }

  /**
   * Obtener campañas pendientes (límite 100)
   */
  getPending(): Observable<any> {
    return this.getCollection('pending');
  }

  /**
   * Obtener campaña por ID
   */
  getById(id: string): Observable<any> {
    return this.getCollection(id);
  }

  /**
   * Ejecutar campaña pendiente manualmente
   */
  execute(id: string): Observable<any> {
    return this.postCollection({}, `${id}/execute`);
  }

  /**
   * Ejecutar campaña ahora (alias de execute para consistencia)
   */
  executeNow(id: string): Observable<any> {
    return this.execute(id);
  }

  /**
   * Cancelar campaña pendiente
   */
  cancel(id: string): Observable<any> {
    return this.postCollection({}, `${id}/cancel`);
  }

  /**
   * Ejecutar cron job de creación de campañas manualmente
   */
  executeManualCronJob(): Observable<any> {
    return this.postCollection({}, 'execute-manual');
  }
}
